// extracted by mini-css-extract-plugin
export default {"text":"Notification_text__oPTah"};